import {
    Form,
    Button,
    Col,
    Checkbox,
    Row
} from "antd";
import { forwardRef, useImperativeHandle } from "react";
import CustomDropDown from "../customDropDown/customDropDown";
import './repoEntryDetails.scss'
import {
    DatePickerField,
    DropdownField,
    RadioField,
    TextField,
    CascadeDropdownField,
    ApiValues,
    SearchableField,
    Field,
    FileUploadField,
    TextAreafield,
    ChildForm,
} from "../../types/field";
import CustomDatePicker from "../datePicker/datepicker";
import moment from "moment";
import { InputComponent } from "../input/inputuncontrolled"
import CustomFileUpload from "../fileupload/fileupload";
import TextAreaInput from "../textArea/textArea";
import CascadeDropDown from "../customDropDown/cascadeDropDown";
import { getApiForField, handleOnBlurOnField, isFieldEditable, isMandatoryField } from "./recordDetailUtils";
import CommonRadioGroup from "../CommonRadioGroup/CommonRadioGroup";
import CustomDateTimePicker from "../dataAndTimePicker/datetimepicker";
import { AdressInputComponent } from "../addressInputComponent/addressInputComponent";
import { SearchableInputComponent } from "../searchableInputComponent/searchableInputComponent";
import { refineApiWithUrlParams } from "./detailsPageCommonsUtils";
import { getRegexForValidation } from "../../utils/getRegexForValidation";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { renderSubHeading, splitArray } from "./detailsPagesUtils";

interface Props {
    form: any,
    handleOnChange: any,
    platformAction: any,
    isEditClicked: any,
    isCreateFlow: any,
    editForm: any,
    urlparams: any,
    handleOnBlur: any,
    handleCascadeOnChange: any,
    addGroupFieldBehaviour?: any,
    dependantFields: any,
    viewData: any,
    renderChildForm?: any,
    selectCheckBox?: any,
    formSchema: any,
    triggerOnChange?: any,
    handleAutoComplete?: any
}

const InputMethods = forwardRef<any, Props>(({
    form,
    handleOnChange,
    platformAction,
    isEditClicked,
    isCreateFlow,
    editForm,
    urlparams,
    handleOnBlur,
    handleCascadeOnChange,
    addGroupFieldBehaviour,
    dependantFields,
    viewData,
    selectCheckBox,
    renderChildForm,
    formSchema,
    triggerOnChange,
    handleAutoComplete
}, ref) => {

    console.log(isEditClicked);
    const {
        control,
    } = useForm<any>({});

    const { t } = useTranslation();

    const setError = (field: string, error: any) => {

        form.setFields([
            {
                name: field, // Field name
                errors: [error.message], // Array of error messages
            }
        ]);
    }

    // Start of Form Fields render methods
    // Below methods should be same in all record details pages - If any change is made - copy the whole to other record details page
    const renderTextBox = (field: TextField) => {
        return field.field === "receiptNatureAmount"
            ? renderTextBoxWithButton(field)
            : renderPlainTextBox(field);
    };

    const renderTextAreainput = (field: TextField) => {

        return (
            <Col span={24} lg={12}>
                <Form.Item
                    label={t(field?.displayName)}
                    name={field?.field}
                    key={field?.displayName}

                    rules={[
                        {
                            required: field?.rules?.length > 0 ? field?.rules[0]?.mandatory : false,
                            message: "Please enter the value.",
                        },
                    ]}
                >
                    <TextAreaInput
                        control={control}
                        name={field.field}
                        title={field?.displayName}
                        setValue={form.setFieldValue}
                        placeholder={field?.placeholder}
                        data={form.getFieldValue(field.field)}
                        disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
                        rules={field?.rules && field?.rules[0]}
                        maxLength={field?.rules[0].maxSize}
                    />
                </Form.Item>
            </Col>
        );
    };

    const renderPlainTextBox = (field: TextField) => {

        //DND - Needed for expressions in blueprint
        let currentDate = moment().format("DD-MMM-YYYY");

        let data = form.getFieldValue(field.field);

        if (data === "currentDate") {

            data = eval(data);
        }

        if (field?.rules[0].defaultType === 'javascript') {
            let currentDate = moment();
            data = eval(field?.rules[0].default).toString();
            form.setFieldValue(field.field, data);
        }

        return (
            <Col span={24} lg={12}>
                <>
                    <Form.Item
                        hidden={field?.hidden}
                        label={t(field?.displayName)}
                        name={field?.field}
                        key={field?.displayName}
                        rules={[
                            {
                                required: field?.rules?.length > 0 ? field?.rules[0]?.mandatory : false,
                                message: "Please enter the value.",
                            },
                            {
                                pattern: field?.rules?.length > 0 ? getRegexForValidation(field?.rules[0]?.allowValues).value : undefined,
                                message: "Please enter valid value.",
                            }
                        ]}
                    >

                        <InputComponent
                            control={control}
                            name={field.field}
                            title={field?.displayName}
                            setValue={form.setFieldValue}
                            placeholder={field?.placeholder}
                            data={data}
                            disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
                            onBlur={(val: any) => {


                                handleOnChange(val, field?.field);

                                const setValue = (field: string, val: any) => {
                                    handleOnChange(val, field);
                                }

                                setTimeout(() => {
                                    handleOnBlurOnField(field, setError, setValue, editForm, form.getFieldsValue, urlparams, {});
                                }, 400);


                                if (field.lookupField && field.lookupFieldEndpoint) {
                                    handleOnBlur(val, field.field, field.lookupField, field.lookupFieldEndpoint)
                                }

                            }
                            }
                            onChange={(val: any) => { }}
                            rules={field?.rules && field?.rules[0]}
                            icon={field.icon}
                        />
                    </Form.Item>
                </>
            </Col>
        );
    };

    const renderAddressField = (field: TextField) => {
        return (
            <Col span={24} lg={12}>
                <>
                    <Form.Item
                        hidden={field?.hidden}
                        label={t(field?.displayName)}
                        name={field?.field}
                        key={field?.displayName}

                        rules={[
                            {
                                required: field?.rules?.length > 0 ? field?.rules[0]?.mandatory : false,
                                message: "Please enter the value.",
                            }
                        ]}
                    >
                        <AdressInputComponent
                            control={control}
                            name={field.field}
                            title={field?.displayName}
                            setValue={form.setFieldValue}
                            placeholder={field?.placeholder}
                            recordId={refineApiWithUrlParams("{loanNo}", urlparams)}
                            data={form.getFieldValue(field.field)}
                            disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
                            onChange={(val: any) => {

                                handleOnChange(val, field?.field)
                            }}
                            rules={field?.rules && field?.rules[0]}
                        />
                    </Form.Item>
                </>
            </Col>
        );
    };


    const renderSearchableInputField = (field: SearchableField) => {

        return (
            <Col span={24} lg={12}>
                <>
                    <Form.Item
                        hidden={field?.hidden}
                        label={t(field?.displayName)}
                        name={field?.field}
                        key={field?.displayName}

                        rules={[
                            {
                                required: field?.rules?.length > 0 ? field?.rules[0]?.mandatory : false,
                                message: "Please enter the value.",
                            },
                            {
                                pattern: field?.rules?.length > 0 ? field?.rules[0]?.pattern : undefined,
                                message: "Please enter valid value.",
                            },
                        ]}
                    >
                        <SearchableInputComponent
                            control={control}
                            name={field.field}
                            title={field?.displayName}
                            setValue={form.setFieldValue}
                            placeholder={field?.placeholder}
                            data={form.getFieldValue(field.field)}
                            disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
                            onChange={(val: any) => {

                                handleOnChange(val, field?.field)
                            }}
                            rules={field?.rules && field?.rules[0]}
                            searchModalProps={field.searchModalProps}
                        />
                    </Form.Item>
                </>
            </Col>
        );
    };

    const renderTextBoxWithButton = (field: TextField) => {

        return (
            <Col span={24} lg={12}>
                <Form.Item
                    label={t(field?.displayName)}
                    name={field?.field}
                    key={field?.displayName}

                    rules={[
                        {
                            required: field?.rules?.length > 0 ? field?.rules[0]?.mandatory : false,
                            message: "Please enter the value.",
                        },
                    ]}
                >
                    <InputComponent
                        control={control}
                        name={field.field}
                        title={field?.displayName}
                        setValue={form.setFieldValue}
                        placeholder={field?.placeholder}
                        data={form.getFieldValue(field.field)}
                        disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
                        onChange={(val: any) => handleOnChange(val, field?.field)}
                        rules={field?.rules && field?.rules[0]}
                    />
                    <Button type="text" danger onClick={() => addGroupFieldBehaviour()}>
                        Add
                    </Button>
                </Form.Item>
            </Col>
        );
    };

    const renderDropDown = (field: DropdownField) => {

        const apiValue: ApiValues = getApiForField(editForm, form.getFieldsValue, field);
        return (
            <Col span={24} lg={12}>
                <Form.Item
                    label={t(field?.displayName)}
                    name={field?.field}
                    key={field?.displayName}

                    rules={[
                        {
                            required: field.rules[0].mandatory ? true : false,
                            message: "Please select the value.",
                        },
                    ]}
                >
                    <div className="dropdown-custom">
                        <CustomDropDown
                            name={field?.field}
                            title={field?.displayName}
                            control={control}
                            setValue={form.setFieldValue}
                            disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
                            onChange={(e: any) => {
                                handleOnChange(e, field?.field);
                                if (field.actions && field.actions.length > 0) {
                                    handleOnBlurOnField(field, setError, form.setFieldValue, editForm, form.getFieldsValue, urlparams, {});
                                }
                            }}
                            api={refineApiWithUrlParams(apiValue.api, urlparams)}
                            rules={field?.rules[0]}
                            dropdownCode={apiValue.dropdownCode}
                            dropdownValue={apiValue.dropdownValue}
                            placeholder={field?.placeholder}
                            showOnlyValue={field?.rules[0].showOnlyValue}
                            value={form.getFieldValue(field.field)}
                            data={form.getFieldValue(field.field)}
                            staticDropDownValues={field.staticDropDownValues ?? []}
                        />
                    </div>
                </Form.Item>
            </Col>
        );
    };

    const renderCascadeDropDown = (field: CascadeDropdownField) => {
        return (
            <Col span={24} lg={12}>
                <Form.Item
                    label={t(field?.displayName)}
                    name={field?.field}
                    key={field?.displayName}
                    rules={[
                        {
                            required: field.rules[0].mandatory ? true : false,
                            message: "Please select the value.",
                        }
                    ]}
                >
                    <div className="dropdown">
                        <CascadeDropDown
                            name={field?.field}
                            title={field?.displayName}
                            control={control}
                            setValue={form.setFieldValue}
                            data={form.getFieldValue(field.field)}
                            disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
                            onChange={(val: any) => {
                                handleOnChange(val, field.field);

                                handleCascadeOnChange(val, field?.field);

                                if (field.actions && field.actions.length > 0) {
                                    handleOnBlurOnField(field, setError, form.setFieldValue, editForm, form.getFieldsValue, urlparams, {});
                                }


                            }}
                            api={refineApiWithUrlParams(field.api ?? "", urlparams)}
                            rules={field?.rules[0]}
                            dropdownCode={field?.dropdownCode}
                            dropdownValue={field?.dropdownValue}
                            placeholder={field?.placeholder}
                            isCascade={
                                field.valuesDependOnField !== undefined &&
                                field.valuesDependOnField !== null &&
                                field.valuesDependOnField !== ""
                            }
                            showOnlyValue={field?.rules[0]?.showOnlyValue}
                            parentFieldValues={viewData}
                            parentFieldName={field?.valuesDependOnField}
                        />
                    </div>

                </Form.Item>
            </Col>
        );
    };

    const renderCalender = (field: DatePickerField) => {
        return (
            <Col span={24} lg={12}>
                <Form.Item
                    label={t(field?.displayName)}
                    name={field?.field}
                    key={field?.displayName}

                    rules={[
                        {
                            required: field.rules[0].mandatory,
                            message: "Please select the value.",
                        },
                    ]}
                >
                    <CustomDatePicker
                        title={field?.displayName}
                        data={form.getFieldValue(field.field)}
                        disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
                        showTime={field?.rules[0].showTime}
                        onChange={(e: any) => {
                            triggerOnChange(field);
                            handleOnChange(e, field.field)
                        }}
                        rules={field?.rules[0]}
                        placeholder={field?.placeholder}
                        control={control}
                        setValue={form.setFieldValue}
                        name={field.field}
                        id={field.field}
                    />
                </Form.Item>
            </Col>
        );
    };

    const renderCalenderWithTime = (field: any) => {
        return (
            <Col span={24} lg={12}>
                <Form.Item
                    label={t(field?.displayName)}
                    name={field?.field}
                    key={field?.displayName}

                    rules={[
                        {
                            required: field.rules[0].mandatory,
                            message: "Please select the value.",
                        },
                    ]}
                >
                    <CustomDateTimePicker
                        title={field?.displayName}
                        data={form.getFieldValue(field.field)}
                        disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
                        showTime={field?.rules[0].showTime}
                        onChange={(e: any) => handleOnChange(e, field.field)}
                        rules={field?.rules[0]}
                        placeholder={field?.placeholder}
                        control={control}
                        setValue={form.setFieldValue}
                        name={field.field}
                        id={field.field}
                    />
                </Form.Item>
            </Col>
        );
    };

    const renderFileUpload = (field: any) => {

        var rules = { ...field.rules[0] };
        rules.fileContext = dependantFields[0]?.field as string;

        return (
            <>
                <Col span={24} lg={12} style={{ display: 'flex', alignItems: 'center' }}>
                    <Form.Item
                        label={t(field?.displayName)}
                        name={field?.field}
                        key={field?.displayName}
                        rules={[
                            {
                                required: rules.mandatory,
                                message: "Please select a File",
                            }
                        ]}
                    >
                        <CustomFileUpload
                            width={200}
                            title={field?.displayName}
                            data={field.childEntity ? form.getFieldValue(field.childEntity) : form.getFieldValue(field.field)}
                            disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
                            onChange={(files: any) => {
                                if (files && files.length > 0) {
                                    if (field.childEntity) {
                                        form.setFieldValue(field.childEntity, files);
                                    } else {
                                        form.setFieldValue(field.field, files[0].fileName);
                                    }
                                } else {
                                    if (field.childEntity) {
                                        form.setFieldValue(field.childEntity, null);
                                    } else {
                                        form.setFieldValue(field.field, null);
                                    }
                                }
                            }
                            }
                            rules={rules}
                            placeholder={field?.placeholder}
                            control={control}
                            setValue={form.setFieldValue}
                            uploadApi={field.api}
                            maxFilesAllowed={field.rules[0].maxFilesAllowed}
                            downloadApi={field.downloadApi}
                            name={field.field}
                            id={field.field}
                            childEntity={field.childEntity}
                            getValue={form.getFieldsValue}
                            handleAutoCompleteAction={handleAutoComplete ? handleAutoComplete : null}
                        />
                    </Form.Item>
                </Col>
            </>
        );
    };

    const renderRadio = (field: RadioField) => {


        return (
            <Col span={12}>
                <Form.Item
                    label={t(field?.displayName)}
                    name={field?.field}
                    key={field?.displayName}

                    rules={[
                        {
                            required: field.rules[0].mandatory,
                            message: "Please select the value.",
                        },
                    ]}
                >
                    <CommonRadioGroup
                        title={t(field?.displayName)}
                        disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
                        rules={field?.rules[0]}
                        api={field.api ?? ""}
                        placeholder={field?.placeholder}
                        onChange={(e: any) => {
                            handleOnChange(e, field?.field)
                        }
                        }
                        control={control}
                        setValue={form.setFieldValue}
                        name={field.field}
                        options={field.values}
                        data={form.getFieldValue(field.field)}
                        uiType={field.uiType}
                    />
                </Form.Item>
            </Col>
        );
    };

    const renderCheckBox = (field: any) => {
        let fieldName = field?.field;
        return (
            <Col span={12} >
                <Form.Item
                    className="mx-1"
                    name={field?.field}
                    key={field?.displayName}

                    rules={[
                        {
                            required: field.rules[0].mandatory,
                            message: "Please select the value.",
                        },
                    ]}
                >
                    <Checkbox
                        type={"checkbox"}
                        checked={form.getFieldValue(field.field)}
                        defaultChecked={form.getFieldValue(field.field)}
                        onChange={(e: any) => {

                            handleOnChange(e.target?.checked, field?.field, true);

                        }}
                        name={field.field}
                        disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
                    >
                        <label className="font-medium"> {t(field?.displayName)} </label>
                    </Checkbox>
                </Form.Item>
            </Col>
        );
    };

    // End of form fields render methods


    // TODO: use enum instead of strings
    const renderField = (field: Field) => {

        if (field.display === false) {
            return;
        }

        if (field.isChildForm) {
            return renderChildForm(field as ChildForm);
        }

        if (selectCheckBox && (form.getFieldsValue()?.[field?.field] == '' || form.getFieldsValue()?.[field?.field] == undefined))
            return

        if (field?.rules && field?.rules[0]) {
            field.rules[0].mandatory = isMandatoryField(field, form.getFieldsValue, editForm);
        }

        if (field.fieldType === "actionButton") {
            return;
        }

        if (!form.getFieldValue(field.field)) {
            if (field.rules && field.rules[0].hasOwnProperty("default") && field?.rules[0].default && field?.rules[0].default.length > 0) {
                form.setFieldsValue({ [field.field]: field?.rules[0].default });
            }
        }


        switch (field.fieldType) {
            case "textBox":
                return renderTextBox(field as TextField);
            case "address":
                return renderAddressField(field as TextField);
            case "searchableField":
                return renderSearchableInputField(field as SearchableField);
            case "formula":
                return renderTextBox(field as TextField);
            case "textArea":
                return renderTextAreainput(field as TextAreafield);
            case "dropDown":
                return renderDropDown(field as DropdownField);
            case "cascadeDropDown":
                return renderCascadeDropDown(field as CascadeDropdownField);
            case "calendar":
                return renderCalender(field as DatePickerField);
            case "radioButton":
                return renderRadio(field as RadioField);
            case "checkBox":
                return renderCheckBox(field as any);
            case "fileUpload":
                return renderFileUpload(field as FileUploadField);
            case "subHeading":
                return renderSubHeading(field as any)
            case "calendarWithTime":
                return renderCalenderWithTime(field as any);
            default:
                return renderPlainTextBox(field as TextField);
        }
    };



    const renderFields = () => {

        if (formSchema.length > 0) {
            const splitArr = splitArray(formSchema, "subHeading");

            if (splitArr.length > 0) {
                return splitArr?.map((field: any) =>
                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 24, xl: 36 }} className="w-100 mx-2 mt-2 sub-tabs">
                        {field.map((subField: Field) => renderField(subField))}
                    </Row>
                )
            } else {
                return <></>
            }

        } else {
            return <></>;
        }
    }
    // Expose only the desired method to parent
    useImperativeHandle(ref, () => ({
        exposedMethod: (field: any) => {
            return renderField(field);
        }
    }));

    return <>{renderFields()}</>

});

export default InputMethods;